module.exports = "<div class=\"dot-slider-area\">\n\t<div class=\"dot-wrapper\">\n\t\t<div class=\"dot dot-{{i}}\" *ngFor=\"let dot of arrNumSliderCounters;let i=index;\" [style.left.px]=\"dot\" [style.background-color]=\"arrStrSliderBgColors[i]\">\n\t\t</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/dot-slider/dot-slider.component.html
// module id = ../../../../../src/app/utilities/dot-slider/dot-slider.component.html
// module chunks = main